import { render, staticRenderFns } from "./how-it-works-integrations.vue?vue&type=template&id=21d68549"
import script from "./how-it-works-integrations.vue?vue&type=script&lang=js"
export * from "./how-it-works-integrations.vue?vue&type=script&lang=js"
import style0 from "./how-it-works-integrations.vue?vue&type=style&index=0&id=21d68549&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports